import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['accessKeyText', 'passwordText', 'modalOverlay', 'votingForm'];

  declare accessKeyTextTarget: HTMLElement;
  declare passwordTextTarget: HTMLElement;
  declare modalOverlayTarget: HTMLElement;
  declare votingFormTarget: HTMLFormElement;
  declare hasAccessKeyTextTarget: boolean;
  declare hasPasswordTextTarget: boolean;
  declare hasModalOverlayTarget: boolean;
  declare hasVotingFormTarget: boolean;

  connect() {
    // Component initialized successfully
  }

  copyCredentials(event: Event): void {
    const button = event.currentTarget as HTMLElement;
    const accessKey = this.accessKeyTextTarget.textContent || '';
    const password = this.passwordTextTarget.textContent || '';
    
    const credentialsText = `Access Key: ${accessKey}\nPassword: ${password}`;
    
    this.fallbackCopyToClipboard(credentialsText, button);
  }

  private fallbackCopyToClipboard(text: string, button: HTMLElement): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // Set styles for cross-browser compatibility
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.style.fontSize = '16px'; // Prevent zoom on iOS
    
    document.body.appendChild(textArea);
    
    // Select the text
    textArea.focus();
    textArea.select();
    
    // iOS compatibility
    try {
      textArea.setSelectionRange(0, 99999);
    } catch (err) {
      // Ignore errors on browsers that don't support setSelectionRange
    }

    // Execute copy command
    let successful = false;
    try {
      successful = document.execCommand('copy');
    } catch (err) {
      // Copy failed
    }
    
    // Clean up
    document.body.removeChild(textArea);
    
    // Show feedback
    if (successful) {
      this.showCopyFeedback(button, 'Credentials');
    } else {
      this.showCopyError(button);
    }
  }

  showConfirmationModal(event: Event): void {
    // ^^ Prevent form submission and show modal instead
    event.preventDefault();
    if (this.hasModalOverlayTarget) {
      this.modalOverlayTarget.classList.remove('otc--available-page-component__modal_hidden');
    }
  }

  closeModal(): void {
    if (this.hasModalOverlayTarget) {
      this.modalOverlayTarget.classList.add('otc--available-page-component__modal_hidden');
    }
  }

  proceedToVoting(): void {
    // ^^ Submit the form to POST the password securely to the backend
    this.votingFormTarget.submit();
  }

  private showCopyFeedback(button: HTMLElement, fieldName: string): void {
    const originalText = button.textContent;
    button.textContent = `${fieldName} Copied!`;
    button.classList.add('otc--available-page-component__copy_credentials_button--success');
    
    setTimeout(() => {
      button.textContent = originalText;
      button.classList.remove('otc--available-page-component__copy_credentials_button--success');
    }, 2000);
  }

  private showCopyError(button: HTMLElement): void {
    const originalText = button.textContent;
    button.textContent = 'Failed';
    button.classList.add('otc--available-page-component__copy_credentials_button--error');
    
    setTimeout(() => {
      button.textContent = originalText;
      button.classList.remove('otc--available-page-component__copy_credentials_button--error');
    }, 2000);
  }
}
